<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#005f32"
      size="60"
      is-full-screen
    />
    <v-snackbar v-model="showSnackBar" color="#005f32" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-card elevation="o" color="#005f32">
          <v-layout wrap justify-center pt-8>
            <v-flex xs12 text-center>
              <span
                style="
                  font-family: poppinsbold;
                  color: #efb727;
                  font-size: 40px;
                  font-weight: 700;
                "
                >CONTACT US</span
              >
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center pb-10>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-layout wrap justify-center class="hidden-md-and-down">
          <v-flex xs12 pt-4>
            <v-layout wrap justify-start>
              <v-flex xs12 sm6>
                <v-layout wrap justify-center>
                  <v-flex xs12 pa-3 pl-16>
                    <v-layout wrap justify-center pl-7>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: poppinsbold;
                            color: #005f32;
                            font-size: 30px;
                            font-weight: 700;
                          "
                          >WILDLIFE TRUST OF INDIA</span
                        >
                      </v-flex>
                      <v-flex
                        xs12
                        text-left
                        pt-3
                        style="
                          font-family: poppinsregular;
                          font-size: 18px;
                          color: black;
                        "
                      >
                        <span>F-13, Sector 8</span><br /><span
                          >National Capital Region (NCR)</span
                        ><br /><span>Noida 201301</span><br /><span>India</span>
                      </v-flex>
                      <v-flex
                        xs12
                        pt-3
                        style="
                          font-family: poppinsregular;
                          font-size: 18px;
                          color: black;
                        "
                      >
                        <v-layout wrap justify-start>
                          <v-flex xs1 text-left
                            ><v-icon color="#005f32">mdi-phone</v-icon></v-flex
                          >
                          <v-flex xs11 text-left
                            ><span>+91 9840981971 / +91-120-4143900 (30 lines)</span></v-flex
                          >
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs12
                        pt-3
                        style="
                          font-family: poppinsregular;
                          font-size: 18px;
                          color: black;
                        "
                      >
                        <v-layout wrap justify-start>
                          <v-flex xs1 text-left
                            ><v-icon color="#005f32"
                              >mdi-email-outline</v-icon
                            ></v-flex
                          >
                          <v-flex xs11 text-left
                            ><span
                              >milind@wti.org.in (Partnership Lead)</span
                            ></v-flex
                          >
                        </v-layout>
                      </v-flex>
                      <v-flex
                        xs12
                        pt-3
                        style="
                          font-family: poppinsregular;
                          font-size: 18px;
                          color: black;
                        "
                      >
                        <v-layout wrap justify-start>
                          <v-flex xs1 text-left
                            ><v-icon color="#005f32">mdi-fax</v-icon></v-flex
                          >
                          <v-flex xs11 text-left
                            ><span>+91-120-4143933 (fax)</span></v-flex
                          >
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 pt-16>
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span
                              style="
                                font-family: poppinsbold;
                                color: #005f32;
                                font-size: 30px;
                                font-weight: 700;
                              "
                              >Join us in making a lasting impact on India's
                              wildlife and ecosystems!</span
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6 lg4>
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <v-layout wrap justify-center pt-4>
                      <v-flex xs12 text-left>
                        <span style="font-family: poppinsregular">Name *</span>
                        <v-text-field
                          outlined
                          v-model="name"
                          dense
                          hide-details="auto"
                          color="#005f32"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 text-left pt-2>
                        <span style="font-family: poppinsregular"
                          >Organisation *</span
                        >
                        <v-text-field
                          outlined
                          dense
                          v-model="organisation"
                          hide-details="auto"
                          color="#005f32"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 text-left pt-2>
                        <span style="font-family: poppinsregular"
                          >Email ID *</span
                        >
                        <v-text-field
                          outlined
                          v-model="email"
                          dense
                          hide-details="auto"
                          color="#005f32"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 text-left pt-2>
                        <span style="font-family: poppinsregular"
                          >Your Query *</span
                        >
                        <v-textarea outlined color="#005f32" v-model="query"> </v-textarea>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <v-btn rounded color="#005f32" @click="verifyInput"
                          ><span
                            style="font-family: poppinsregular; color: white"
                            >SUBMIT</span
                          ></v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start fill-height class="hidden-lg-and-up">
          <v-flex xs12 sm12 pt-5>
            <v-layout wrap justify-start>
              <v-flex xs12>
                <v-layout wrap justify-start>
                  <v-flex xs12 sm6 md6>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <v-layout wrap justify-center pl-4 pl-sm-5 pl-md-8>
                          <v-flex xs12 text-left>
                            <span
                              style="
                                font-family: poppinsbold;
                                color: #005f32;
                                font-size: 30px;
                                font-weight: 700;
                              "
                              >WILDLIFE TRUST OF INDIA</span
                            >
                          </v-flex>
                          <v-flex
                            xs12
                            text-left
                            pt-3
                            style="
                              font-family: poppinsregular;
                              font-size: 18px;
                              color: black;
                            "
                          >
                            <span>F-13, Sector 8</span><br /><span
                              >National Capital Region (NCR)</span
                            ><br /><span>Noida 201301</span><br /><span
                              >India</span
                            >
                          </v-flex>
                          <v-flex
                            xs12
                            pt-3
                            style="
                              font-family: poppinsregular;
                              font-size: 18px;
                              color: black;
                            "
                          >
                            <v-layout wrap justify-start>
                              <v-flex xs1 text-left
                                ><v-icon color="#005f32"
                                  >mdi-phone</v-icon
                                ></v-flex
                              >
                              <v-flex xs11 text-left
                                ><span>+91 9840981971 / +91-120-4143900 (30 lines)</span></v-flex
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs12
                            pt-3
                            style="
                              font-family: poppinsregular;
                              font-size: 18px;
                              color: black;
                            "
                          >
                            <v-layout wrap justify-start>
                              <v-flex xs1 text-left
                                ><v-icon color="#005f32"
                                  >mdi-email-outline</v-icon
                                ></v-flex
                              >
                              <v-flex xs11 text-left
                                ><span
                                  >milind@wti.org.in (Partnership Lead)</span
                                ></v-flex
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs12
                            pt-3
                            style="
                              font-family: poppinsregular;
                              font-size: 18px;
                              color: black;
                            "
                          >
                            <v-layout wrap justify-start>
                              <v-flex xs1 text-left
                                ><v-icon color="#005f32"
                                  >mdi-fax</v-icon
                                ></v-flex
                              >
                              <v-flex xs11 text-left
                                ><span>+91-120-4143933 (fax)</span></v-flex
                              >
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 pt-5 pt-sm-16 pl-0 pl-sm-3 pl-md-0>
                        <v-layout wrap justify-center>
                          <v-flex xs12>
                            <span
                              style="
                                font-family: poppinsbold;
                                color: #005f32;
                                font-size: 30px;
                                font-weight: 700;
                              "
                              >Join us in making a lasting impact on India's
                              wildlife and ecosystems!</span
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-layout wrap justify-center>
                      <v-flex xs10 sm9 md8>
                        <v-layout wrap justify-center>
                          <v-flex xs12 text-left>
                            <span style="font-family: poppinsregular"
                              >Name *</span
                            >
                            <v-text-field
                              outlined
                              v-model="name"
                              dense
                              hide-details="auto"
                              color="#005f32"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 text-left pt-2>
                            <span style="font-family: poppinsregular"
                              >Organisation *</span
                            >
                            <v-text-field
                              outlined
                              dense
                              v-model="organisation"
                              hide-details="auto"
                              color="#005f32"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 text-left pt-2>
                            <span style="font-family: poppinsregular"
                              >Email ID *</span
                            >
                            <v-text-field
                              outlined
                              dense
                              v-model="email"
                              hide-details="auto"
                              color="#005f32"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 text-left pt-2>
                            <span style="font-family: poppinsregular"
                              >Your Query *</span
                            >
                            <v-textarea outlined color="#005f32" v-model="query"> </v-textarea>
                          </v-flex>
                          <v-flex xs12 text-center>
                            <v-btn rounded color="#005f32" @click="verifyInput"
                              ><span
                                style="
                                  font-family: poppinsregular;
                                  color: white;
                                "
                                >SUBMIT</span
                              ></v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  // metaInfo: {
  //   title: "Contact TaxMind - Get in Touch with Our Experts",
  //   meta: [
  //     {
  //       name: "description",
  //       content:
  //         "Need tax or financial assistance? Contact TaxMind today for expert advice on tax filing, financial planning, and business consultancy.",
  //     },
  //     {
  //       name: "keywords",
  //       content:
  //         "contact TaxMind, tax consultation, financial advice, tax support, business consultancy, tax help, financial planning, customer support",
  //     },
  //     {
  //       property: "og:title",
  //       content: "Contact TaxMind - We're Here to Help",
  //     },
  //     {
  //       property: "og:description",
  //       content:
  //         "Reach out to TaxMind for expert tax and finance guidance. Our team is ready to assist you with all your tax and financial queries.",
  //     },
  //     {
  //       property: "og:url",
  //       content: "https://www.taxmind.ie/contact-us", // Replace with the actual Contact Us page URL
  //     },
  //     {
  //       property: "og:type",
  //       content: "website",
  //     },
  //     { name: "robots", content: "index, follow" },
  //   ],
  // },

  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      name: null,
      organisation: null,
      email: null,
      query: null,
    };
  },
  methods: {
    verifyInput() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const nameRegex = /^[A-Za-z\s]+$/;
      if (!this.name) {
        this.msg = "Please Provide Name";
        this.showSnackBar = true;
        return;
      }
      if (!nameRegex.test(this.name)) {
        this.msg = "Name can only contain alphabets";
        this.showSnackBar = true;
        return;
      }
      if (!this.organisation) {
        this.msg = "Please Provide Organisation";
        this.showSnackBar = true;
        return;
      }
      if (!this.email) {
        this.msg = "Please Provide Email";
        this.showSnackBar = true;
        return;
      }
      if (!emailRegex.test(this.email)) {
        this.msg = "Please Provide a Valid Email.";
        this.showSnackBar = true;
        return;
      }
      if (!this.query) {
        this.msg = "Please Provide Your Ouery";
        this.showSnackBar = true;
        return;
      }
      
      this.login();
    },
    login() {
      this.appLoading = true;
      let user = {};
      user["name"] = this.name;
      user["organisation"] = this.organisation;
      user["email"] = this.email;
      user["query"] = this.query;
      axios({
        method: "POST",
        url: "/contactus/form/submit",
        data: user,
        // headers: {
        //   token: localStorage.getItem("token"),
        // },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.message;
            this.showSnackBar = true;
            this.name = null;
            this.email = null;
            this.query = null;
            this.organisation = null;
          } else {
            this.msg = response.data.message;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>